import gql from "graphql-tag";

export const LOGOUT_MUTATION = gql`
  mutation LOGOUT {
    logout {
      status
    }
  }
`;
